/* ============================================================
   Marketfit · Regalo de bienvenida como line item property
   - Fila compacta que se despliega al pulsar "Cambiar".
   - Copia el regalo elegido a un input oculto
     name="properties[Regalo]" dentro del <form> de compra de Impulse
     (los radios visibles viven fuera de ese form).
   ============================================================ */
(function () {
  var HIDDEN = 'mf-regalo-hidden';

  function atcForm() {
    return document.querySelector('form[data-type="add-to-cart-form"]');
  }

  function ensureHidden(form) {
    var h = form.querySelector('input.' + HIDDEN);
    if (!h) {
      h = document.createElement('input');
      h.type = 'hidden';
      h.name = 'properties[Regalo]';
      h.className = HIDDEN;
      form.appendChild(h);
    } else if (!form.contains(h)) {
      form.appendChild(h);
    }
    return h;
  }

  function selected() {
    return document.querySelector('.mf-gift input[name="mf-regalo"]:checked');
  }

  function sync() {
    var form = atcForm();
    var sel = selected();
    if (!sel) return;
    if (form) ensureHidden(form).value = sel.value;
    var label = document.querySelector('[data-mf-gift-current]');
    if (label) label.textContent = sel.value;
  }

  function togglePanel(force) {
    var panel = document.querySelector('[data-mf-gift-panel]');
    var btn = document.querySelector('[data-mf-gift-toggle]');
    if (!panel || !btn) return;
    var open = force != null ? force : panel.hasAttribute('hidden');
    if (open) panel.removeAttribute('hidden');
    else panel.setAttribute('hidden', '');
    btn.setAttribute('aria-expanded', String(open));
    btn.textContent = open ? 'Listo' : 'Cambiar';
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-mf-gift-toggle]');
    if (t) {
      e.preventDefault();
      togglePanel();
    }
  });

  document.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'mf-regalo') {
      sync();
      togglePanel(false);
    }
  });

  // Antes de que Impulse serialice el form para /cart/add
  document.addEventListener(
    'submit',
    function (e) {
      if (e.target && e.target.getAttribute('data-type') === 'add-to-cart-form') sync();
    },
    true
  );

  if (document.readyState !== 'loading') sync();
  else document.addEventListener('DOMContentLoaded', sync);
  setTimeout(sync, 1500);
})();
